import React from 'react';
import { Col, Container, Row, Card, Button, Table } from 'react-bootstrap';
import DownloadIcon from '@mui/icons-material/Download';
import { FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import AnswerModal from '../modal/AnswerModal';

const StatisticsTab = () => {
  return (
    <div>
      <Container>
        <Row className=" mt-4">
          <Col>
            <Card className=" shadow-sm px-5 py-4" border="0">
              <Row>
                <Col xs={4} className="mb-4">
                  <div className="mb-2">
                    <h4 className="text-secondary" style={{ marginBottom: '0', color: '#505050' }}>
                      Numbers
                    </h4>
                  </div>
                </Col>
                <Col className="mb-4 text-end d-flex align-items-center justify-content-end" xs={8}>
                  <div className="staticticsBtn">
                    <button type="button" className="btn-1">
                      Numbers
                    </button>
                    <button type="button" className="btn-2">
                      Numbers + Chart
                    </button>
                  </div>
                  <Button
                    className="btn btn-primary me-3"
                    style={{
                      background: '#6A6A6A',
                      border: 'none',
                      borderRadius: '6px',
                      fontSize: '0.875rem',
                      color: '#fff',
                      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px',
                    }}
                  >
                    <DownloadIcon /> Download
                  </Button>
                </Col>
                <Col xs={12}>
                  <div className="answerTableWrp">
                    <Table striped="rows" className="text-center">
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Question</th>
                          <th>Results</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>1</td>
                          <td>What is your name</td>
                          <td>N/A (This is qualitative data)</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default StatisticsTab;
